export const ADMIN_ROUTES = {
  USERMANAGEMENT: '/settings/users/overview/' as const,
  ZEROTRUSTMANAGEMENT: '/settings/users/overview?vpn=true' as const,
  GROUPMANAGEMENT: '/settings/groups/overview/' as const,
  ADDRESSMANAGEMENT: '/settings/branches/overview/' as const,
  SETTINGS: '/settings/settings/overview/' as const,
};
